import type { TextSize } from '@octopus-do/octopus-project-core'
import {
  TextSizeL,
  TextSizeM,
  TextSizeS,
} from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

// Key the menu reports to Toolbar.Root; the picked TextSize follows it.
export const TEXT_SIZE_MENU_ID = 'text_size'

export interface TextSizeOption {
  icon: React.FC<{ className?: string }>
  id: TextSize
  tooltip: string
}

export const TEXT_SIZE_OPTIONS: TextSizeOption[] = [
  { icon: TextSizeS, id: 's', tooltip: 'Small' },
  { icon: TextSizeM, id: 'm', tooltip: 'Medium' },
  { icon: TextSizeL, id: 'l', tooltip: 'Large' },
]
